import { render, staticRenderFns } from "./name-cell.vue?vue&type=template&id=23739a2d&scoped=true&"
import script from "./name-cell.vue?vue&type=script&lang=js&"
export * from "./name-cell.vue?vue&type=script&lang=js&"
import style0 from "./name-cell.vue?vue&type=style&index=0&id=23739a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23739a2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23739a2d')) {
      api.createRecord('23739a2d', component.options)
    } else {
      api.reload('23739a2d', component.options)
    }
    module.hot.accept("./name-cell.vue?vue&type=template&id=23739a2d&scoped=true&", function () {
      api.rerender('23739a2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reference-clients/data-table/name-cell.vue"
export default component.exports